import React from 'react';
import { Button, Stack, Box } from '@mui/material';
import type { Stylist } from '@app-types/models/stylist';

export interface StylistSelectorProps {
  stylists: Stylist[];
  selectedStylistId?: string;
  onStylistSelect: (value: Stylist | string) => void;
  variant?: 'default' | 'id';
  layout?: 'scroll' | 'wrap';
  showEmail?: boolean;
}

const StylistSelector: React.FC<StylistSelectorProps> = ({
  stylists,
  selectedStylistId,
  onStylistSelect,
  variant = 'default',
  layout = 'scroll',
  showEmail = false
}) => {
  const handleSelect = (stylist: Stylist): void => {
    onStylistSelect(variant === 'default' ? stylist : stylist._id);
  };

  const renderButton = (stylist: Stylist): React.ReactElement => (
    <Button
      key={stylist._id}
      variant={selectedStylistId === stylist._id ? 'contained' : 'outlined'}
      onClick={() => handleSelect(stylist)}
      sx={layout === 'scroll' ? { mr: 1 } : undefined}
    >
      {stylist.displayName || (showEmail ? stylist.email : '')}
    </Button>
  );

  if (layout === 'scroll') {
    return (
      <Stack
        direction="row"
        spacing={2}
        sx={{
          mb: 2,
          mt: 2,
          width: 'calc(100vw - 52px)',
          overflowX: 'auto'
        }}
      >
        {stylists.map(renderButton)}
      </Stack>
    );
  }

  return (
    <Box sx={{ mb: 3, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {stylists.map(renderButton)}
    </Box>
  );
};

export default StylistSelector;
